import { useContext, useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import ReactGA4 from 'react-ga4';

import { AuthContext } from '../services/authContextProvider';
import { primaryTheme } from '../themes/primatrytheme';
import { Navbar } from './Components/Navbar/Navbar';
import { ResumesSearch } from './Components/ResumesSearch/ResumesSearch';

import { SESSION_START } from './utils/constants';
import SESSION_ID from './utils/sessionID';
import { LoadingComponent } from './Common/LoadingComponent/LoadingComponent';

export const App = () => {
  const authContext = useContext(AuthContext);
  const gaMeasurementId = process.env.REACT_APP_GA_TRACKING_ID;

  useEffect(() => {
    if (gaMeasurementId) {
      ReactGA4.initialize(gaMeasurementId);
      ReactGA4.event('filter', {
        event_name: SESSION_START,
        ga_session_id: SESSION_ID,
      });
    }
  }, [gaMeasurementId]);

  if (!authContext.isAuthenticated) return <LoadingComponent />;

  return (
    <ThemeProvider theme={primaryTheme}>
      <Navbar />
      <ResumesSearch />
    </ThemeProvider >
  );
};
